type Feature = "migration_checklist" | "change_tracker" | "share_report";
type Placement = "homepage" | "resolver_results" | "all_records";

// Only fixed categories are sent; queried domains and DNS answers stay local.
export function trackFeature(feature: Feature, placement: Placement) {
  try {
    if (localStorage.getItem("cookie-consent") !== "accept") return;
    const analytics = window as Window & { gtag?: (...args: unknown[]) => void };
    analytics.gtag?.("event", "feature_click", {
      send_to: "G-8WWGMHG3R0",
      feature,
      placement,
      page_location: window.location.origin + window.location.pathname,
    });
  } catch { /* Analytics must never prevent navigation or report creation. */ }
}
